import React, { ReactNode, useState } from "react";
import AccordionButton from "../../accordionButton";

const FooterSmall = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <div className="border-b border-gray-200">
      <div
        className={`text-base font-semibold flex justify-between py-4 relative ${
          show ? "border-b border-primary" : ""
        }`}
      >
        <AccordionButton title={title} setShow={setShow} show={show} />
      </div>
      <div
        className={`py-3 px-1 ${
          show ? "flex flex-col gap-3" : "hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default FooterSmall;
